import ApiService from '../../services/apiService';
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreUserfinder',
  props: {
    hideIcon: {
      type: Boolean,
      default: () => false
    },
    label: {
      type: String,
      default: () => ''
    },
    userId: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      titleLimit: 60,
      entries: [],
      isLoading: false,
      rules: [v => !!v || this.$i18n_t('Common.userIsRequired')],
      lclObject: null,
      search: null,
      lastSearch: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    userSearchResult() {
      return this.entries.map(entry => {
        const name = `${entry.firstName} ${entry.lastName} (${entry.email})`;
        const title = name.length > this.titleLimit ? `${name.slice(0, this.titleLimit)}...` : name;
        return Object.assign({}, entry, {
          title,
          id: entry.id
        });
      });
    }
  },
  watch: {
    search: debounce(function () {
      // Items have already been requested
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.fetch();
    }, 100),
    userId() {
      this.findUserObject();
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    process() {
      this.$emit('userSelected', this.lclObject);
    },
    fetch() {
      this.isLoading = true;
      const currentSearch = this.search || this.lastSearch;
      if (this.lastSearch === currentSearch || (this.lclObject || {}).title === currentSearch) {
        this.isLoading = false;
        return;
      }
      this.lastSearch = currentSearch;
      ApiService.fetchUsers([], ['ancestors'], [], 0, 100, undefined, currentSearch).then(data => {
        this.count = data.users.length;
        this.entries = data.users;
      }).catch(error => {
        console.error('Error finding Users', error);
      }).finally(() => this.isLoading = false);
    },
    findUserObject(lookedUp = false) {
      this.lclObject = this.userSearchResult.find(item => {
        return item.id === this.userId;
      });
      if (!this.lclObject && this.userId && !lookedUp) {
        this.isLoading = true;
        ApiService.fetchUsers([], ['ancestors'], [], 0, 100, undefined, this.userId).then(data => {
          this.count = data.users.length;
          this.entries = data.users;
          this.findUserObject(true);
        }).catch(error => {
          console.error('Error finding Users', error);
        }).finally(() => this.isLoading = false);
      }
    }
  }
};